import { defineStore } from "pinia";

export const useWizardStepsStore = defineStore('timeline', {
  state: (): State => {
    return {
      steps: {} as Step,
      currentStep: {} as Step,
      previousSteps: [],
      loading: false,
      error: false,
    }
  },
})